import { ReactNode } from "react";
import { useMsal } from "@azure/msal-react";

/**
 * Gate for routes whose data is confidential to a short allowlist of accounts
 * (e.g. Bills & Subscriptions — owner/HR/Accounting only), as opposed to
 * ProtectedRoute which only checks "is signed in at all". Renders an access
 * notice instead of redirecting, so the URL itself doesn't leak whether the
 * module exists to someone who guesses it.
 */
export function RestrictedRoute({ allowedUsers, moduleName, children }: {
  allowedUsers: string[];
  moduleName: string;
  children: ReactNode;
}) {
  const { accounts } = useMsal();
  const email = accounts[0]?.username?.toLowerCase();
  const allowed = allowedUsers.length === 0 || (!!email && allowedUsers.includes(email));

  if (!allowed) {
    return (
      <div className="restricted-screen">
        <div className="restricted-icon" aria-hidden="true">🔒</div>
        <div className="restricted-title">Restricted</div>
        <div className="restricted-message">
          {moduleName} is limited to specific accounts. Contact the owner if you believe you should have access.
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
